module.exports = __webpack_public_path__ + "img/Messages.65df5aae.svg";